import { ColumnType } from '@datachain/ui-sdk/components/dc-types';
import { immerable, produce } from 'immer';

interface ISimulationColumnsItemEntity {
	id: string;
	label: string;
	alias: string;
	description: string;
	type: ColumnType;
	isList: boolean;
	isHashed: boolean;
	dxDataType: string;
	sortOrder: 'asc' | 'desc' | '';
	sortIndex: number | null;
}

const entityDefaults: ISimulationColumnsItemEntity = {
	id: '-1',
	label: '',
	alias: '',
	description: '',
	type: ColumnType.Unknown,
	isList: false,
	isHashed: false,
	dxDataType: 'string',
	sortOrder: '',
	sortIndex: null,
};

export class SimulationColumnsItemEntity
	implements ISimulationColumnsItemEntity
{
	private [immerable] = true;
	public id = entityDefaults.id;
	public label = entityDefaults.label;
	public alias = entityDefaults.alias;
	public description = entityDefaults.description;
	public type = entityDefaults.type;
	public isList = entityDefaults.isList;
	public isHashed = entityDefaults.isHashed;
	public dxDataType = entityDefaults.dxDataType;
	public sortOrder = entityDefaults.sortOrder;
	public sortIndex = entityDefaults.sortIndex;

	public static build(
		params: Partial<ISimulationColumnsItemEntity> = {}
	): SimulationColumnsItemEntity {
		const inst = new SimulationColumnsItemEntity();
		inst.id = params.id ?? entityDefaults.id;
		inst.label = params.label ?? entityDefaults.label;
		inst.alias = params.alias ?? entityDefaults.alias;
		inst.description = params.description ?? entityDefaults.description;
		inst.type = params.type ?? entityDefaults.type;
		inst.isList = params.isList ?? entityDefaults.isList;
		inst.isHashed = params.isHashed ?? entityDefaults.isHashed;
		inst.dxDataType = params.dxDataType ?? entityDefaults.dxDataType;
		inst.sortOrder = params.sortOrder ?? entityDefaults.sortOrder;
		inst.sortIndex = params.sortIndex ?? entityDefaults.sortIndex;

		return inst;
	}

	private constructor() {}

	public setSortOrder(
		order: 'asc' | 'desc',
		sortIndex: number
	): SimulationColumnsItemEntity {
		return produce(this, (draft) => {
			draft.sortOrder = order;
			draft.sortIndex = sortIndex;
		});
	}
}
